import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/project6/sunsmart_3d.jpg'
import image2 from '../../layouts/images/project6/01_onboarding.jpg'
import image3 from '../../layouts/images/project6/02_data_entry.jpg'
import image4 from '../../layouts/images/project6/03_home_screen_v1.jpg'
import image5 from '../../layouts/images/project6/04_home_screen_v2.jpg'
import image6 from '../../layouts/images/project6/05_home_screen_v3.jpg'
import image7 from '../../layouts/images/project6/06_home_screen_v4.jpg'
import image8 from '../../layouts/images/project6/07_sunscreen_calculator.jpg'
import image9 from '../../layouts/images/project6/003_sunsmart_home_screen_foo.png'
import image10 from '../../layouts/images/project6/sunsmart_promo_high_uv.png'

const SunSmartPage = () => (
    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>UX Case Study: SunSmart 2014</h3>
                <div className="project-content">

                    <p><i>"Our senses cannot detect UV so it can be damaging without us knowing. There is a huge variation in UV levels across Australia. The UV level is affected by a number of factors including the time of day, time of year, cloud cover, altitude, proximity to the equator, scattering and reflection."</i> This app makes it easier than ever to be smart about sun exposure all year round.</p>

                    <p>SunSmart runs on iPhone, iPad and Android, has had over 100,000 downloads and has thousands of daily users. One year after the first release it was time to not only refresh the SunSmart brand, but to improve key features of the app.</p>
                    <p>The initial client meetings resulted in the following tasks:</p>
                    <ul>
                        <li>Refresh of the SunSmart brand</li>
                        <li>Rethink of the app features e.g. onboarding and home screen</li>
                        <li>Add new functionality to the sign up &amp; information input screens</li>
                        <li>Solve the problem of how to capture user information for more accurate sunscreen calculations and to capture demographic and user behavior data for future studies.</li>
                    </ul>
                    <p>We started working out the approach we would ideally like to take and then calculated how long we would need to do that work so we could then adjust the methods, tools and techniques to fit the constraints of the project. First, the use of methods like competitor, heuristic and metric analysis gave us the necessary informational foundation for initial sketches and wireframes which eventually resulted in a prototype ready to be tested by users and stakeholders.</p>

                    <p>One of the major challenges of that project was the onboarding and home screen experience. Resulting from the research, the richness of information on the home screen felt very overwhelming for the user. However the client was very insistent that all of the information was essential. The weather forecast, high and low temperatures, highest and current UV level, and the highlighted sun screen alert times had to be structured in a way to not stress out the user and fulfill the expectations of the client. We believe the end result captured these requirements.</p>
                    <p>Further information about the research will be provided upon request.</p>
                </div>
            </div>

            <div className="col-lg-7">

                <div className="slider">
                    <ImageGallery
                        showThumbnails={false}
                        showFullscreenButton={false}
                        autoPlay={true}
                        items={[
                            { original: image1, },
                            { original: image2, },
                            { original: image3, },
                            { original: image4, },
                            { original: image5, },
                            { original: image6, },
                            { original: image7, },
                            { original: image8, },
                            { original: image9, },
                            { original: image10, },
                        ]} />
                </div>

                <br />
                <br />

                <p className="project-blurb">The slides show the finished product, a time schedule and some early sketches of a project taking shape.</p>

                <ul className="tags">
                    <li>Contextual observations, interviews and testing</li>
                    <li>Analytics</li>
                    <li>Diary studies</li>
                    <li>Sketching</li>
                    <li>Wireframes</li>
                    <li>Prototypes</li>
                </ul>

                <div className="footer-info">
                    <p><span className="highlight">Cooperation Partner:</span> Boosted Human, Cancer Council Victoria and Vic Health</p>
                    <p><span className="highlight">Source:</span> Boosted Human</p>
                    <p><span className="highlight">Date:</span> 2014 - Present</p>
                </div>

            </div>
        </div>
    </div>
)

export default SunSmartPage



// WEBPACK FOOTER //
// ./src/pages/projects/sunsmart.js